
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import OverviewPanel from '../projectOverviewPage/OverviewPanel';
import SelectOpsubWithIsknDate from '../../components/common/iskn/SelectOpsubWithIsknDate';

const classNames = mergeStyleSets({
    content: {
        paddingTop: 16
    }
});

const SelectOpsubPanel = ({
    getOpsub,
    isknDate,
    opsubItem,
    opsubItems,
    projectId,
    projectKatuzeKod,
    title,
    token,
    onChange
}) => {

    return (
        <OverviewPanel title={title} loaded={true} panelWidth="500px">
            <Stack className={classNames.content} tokens={{childrenGap: 16}}>
                <SelectOpsubWithIsknDate
                    isknDate={isknDate}
                    opsubItem={opsubItem}
                    opsubItems={opsubItems}
                    projectId={projectId}
                    projectKatuzeKod={projectKatuzeKod}
                    token={token}
                    getOpsub={getOpsub}
                    onChange={onChange}
                />
            </Stack>
        </OverviewPanel>
    );
}

export default SelectOpsubPanel;
